import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import Footer from 'src/layouts/dashboard/footer/footer';
import FooterSection from 'src/layouts/dashboard/footer/footerSection';
import { Routes } from 'src/routes';
import MainPage from './MainPage';
import MenuBarComponent from './components/navbar/MenuBar';
import ProfileSection from './components/navbar/profile-section/ProfileSection';
import Header from './layouts/dashboard/header/header.component';
import MobileHeader from './layouts/dashboard/header/mobile/mobile-header.component';
import { getSettingsMenu, navSidebar } from './layouts/dashboard/leftNavigation/config';
import Spinner from './utils/Loader/spinner';
import { CommonHelper } from './utils/commonHelper';
import { LocalStorage } from './utils/storage/local-storage';
import { SessionStorage } from './utils/storage/session-storage';
//import SupportChat from './components/support-chat/SupportChat';

const MainComponent = ({ isDesktop, handleInitCall }) => {
  const { t: translate, i18n } = useTranslation();
  const isReferralUser = CommonHelper.IsReferralUser();
  const isResellerWithoutOrgAdminPermission = CommonHelper.CheckIsResellerWithoutOrgAdminPermission();
  const location = useLocation();
  const isBrandPaymentRoute = /^\/(brand-payment|brand-checkout)\/[^/]+\/?$/.test(location.pathname);
  const navigate = useNavigate();
  const privateRoutes = Routes.PrivateRoute();
  const publicRoutes = Routes.PublicRoutes();

  let settingsMenu = getSettingsMenu(translate);

  if (!isReferralUser) {
    settingsMenu[0].menu = settingsMenu[0].menu.filter((a) => a.title !== translate('navbar.menu.refer_and_earn'));
  }
  if (isResellerWithoutOrgAdminPermission) {
    settingsMenu[0].menu = settingsMenu[0].menu.filter((a) => a.title !== translate('navbar.menu.manage_organization'));
  }
  const mainMenuItems = navSidebar(translate);

  const [processedMenuItems, setProcessedMenuItems] = useState([]);
  const [processedSettingsMenuItems, setProcessedSettingsMenuItems] = useState([]);
  const [menuItems, setMenuItems] = useState([]);
  const [showSideBar, setSideBar] = useState(false);
  const [headerName, setHeaderName] = useState('');
  const [isMainMenuBarView, setMainMenuBarView] = useState(true);
  const [isRouteLoaded, setRouteLoaded] = useState(false);
  const [brandPermissions, setBrandPermissions] = useState(CommonHelper.GetBrandInfoFromLocalStorage('permissions'));
  const userOrgDetails = CommonHelper.GetBrandInfoFromLocalStorage();
  const [routes, setRoutes] = useState(publicRoutes);
  const [showPlanDetailsPopup, setShowPlanDetailsPopup] = useState(false);
  const [isSupportChatOpen, setSupportChatOpen] = useState(false);
  const [isOrgUser, setOrgUser] = useState(false);
  const isShowOfferBanner = CommonHelper.ShowOfferBanner();
  const isCustomDomain = CommonHelper.CustomDomain();

  useEffect(() => {
    preProcessMenuItems();
  }, []);

  useEffect(() => {
    if (!isCustomDomain) return;

    const hideBrand2ChatWidget = () => {
      if (window.Brand2Chat_API?.hideWidget) {
        window.Brand2Chat_API.hideWidget();
      }
    };

    window.Brand2Chat_API = window.Brand2Chat_API || {};
    window.Brand2Chat_API.onLoad = hideBrand2ChatWidget;
    hideBrand2ChatWidget();

    const widgetHideInterval = setInterval(hideBrand2ChatWidget, 1000);
    const clearWidgetHideInterval = setTimeout(() => clearInterval(widgetHideInterval), 10000);

    return () => {
      clearInterval(widgetHideInterval);
      clearTimeout(clearWidgetHideInterval);
    };
  }, []);

  useEffect(() => {
    handleRouteLoading(false);
    handleSideBar();
    if (!isOrgUser) {
      if (CommonHelper.GetBrandInfoFromLocalStorage('is_org_user')) {
        setOrgUser(true);
        // if(!isIntegSocial) {
        //   handleTrailPlanPopup();
        // }
      }
    }
  }, [location.pathname, processedMenuItems, processedSettingsMenuItems]);

  useEffect(() => {
    preProcessMenuItems();
  }, [brandPermissions]);

  // useEffect(() => {
  //   handleTrailPlanPopup();
  // }, [processedMenuItems, processedSettingsMenuItems]);

  const handleRouteLoading = (isRouteLoaded) => {
    setRouteLoaded(isRouteLoaded);
    LocalStorage.setItem('isRouteLoaded', JSON.stringify(isRouteLoaded));
  };

  const checkAndLoadRoutes = () => {
    const isUserLoggedIn = CommonHelper.CheckUserLoggedIn();
    if (isUserLoggedIn) {
      let allRoutes = getAllRoutes();
      setRoutes([...allRoutes]);
    } else {
      setRoutes([...publicRoutes]);
    }
    handleRouteLoading(true);
  };

  const getAllRoutes = () => {
    let allRoutes = privateRoutes.concat(publicRoutes);
    return allRoutes;
  };

  const handleSideBar = () => {
    if (processedMenuItems.length > 0) {
      let route = Routes.PrivateRoute().find((a) => a.path === location.pathname.replace('/', ''));
      if (route) {
        let hName = GetHeaderName(processedMenuItems);
        if (hName) {
          setMainMenuBarView(true);
          setMenuItems([...processedMenuItems]);
        } else {
          setMainMenuBarView(false);
          hName = GetHeaderName(processedSettingsMenuItems);
          setMenuItems([...processedSettingsMenuItems]);
        }
        setHeaderName(hName);
      } else {
        setHeaderName('');
      }

      let showSidebar = !!route;
      setSideBar(showSidebar);
      checkAndLoadRoutes();
    } else {
      preProcessMenuItems();
    }
  };

  const GetHeaderName = (menuItems) => {
    let headerName = '';
    const menuPath = location.pathname.startsWith('/ai-connections/') ? '/ai-connections' : location.pathname;
    for (var i = 0; i < menuItems.length; i++) {
      var item = menuItems[i];
      let pathMenu = item.menu.find((a) => a.path === menuPath);
      if (pathMenu) {
        headerName = pathMenu.title;
        break;
      }
    }
    return headerName;
  };

  const preProcessMenuItems = () => {
    if (brandPermissions) {
      let processedMenuItems = [];
      let processedSettingsMenuItems = [];
      mainMenuItems.map((menuItem) => {
        let groupMenuItems = [];
        menuItem.menu.map((item) => {
          let isShowMenuBar = checkForPermission(item.permissions);
          if (isShowMenuBar) {
            groupMenuItems.push(item);
          }
        });
        if (groupMenuItems?.length > 0) {
          let pMenuItems = {
            title: menuItem.title,
            menu: [...groupMenuItems],
          };
          processedMenuItems.push(pMenuItems);
        }
      });
      settingsMenu.map((menuItem) => {
        let groupMenuItems = [];
        menuItem.menu.map((item) => {
          let isShowMenuBar = checkForPermission(item.permissions);
          if (item?.portalAdmin) {
            isShowMenuBar = userOrgDetails.is_portal_admin;
            //For Testing
            // isShowMenuBar = true;
          }
          if (isShowMenuBar) {
            groupMenuItems.push(item);
          }
        });
        if (groupMenuItems?.length > 0) {
          let pMenuItems = {
            title: menuItem.title,
            menu: [...groupMenuItems],
          };
          processedSettingsMenuItems.push(pMenuItems);
        }
      });
      setProcessedMenuItems([...processedMenuItems]);
      setProcessedSettingsMenuItems([...processedSettingsMenuItems]);
    } else {
      handleRouteLoading(true);
    }
  };

  const checkForPermission = (permissions) => {
    let isPermissionAvailable = false;
    if (permissions) {
      if (brandPermissions[permissions]) {
        isPermissionAvailable = true;
      } else {
        isPermissionAvailable = false;
      }
    }
    return isPermissionAvailable;
  };

  const backButtonClick = () => {
    navigate(CommonHelper.DefaultPermissionRoute);
    setMenuItems([...mainMenuItems]);
  };

  const handleChangeBrand = (brandId) => {
    handleRouteLoading(false);
    let data = CommonHelper.GetBrandInfoFromLocalStorage();
    if (data) {
      SessionStorage.setItem('current_brand_id', JSON.stringify(brandId));
      let brand_details = data.brand_details.find((a) => a.brand_id === brandId);
      if (brand_details) {
        setBrandPermissions(brand_details.permission_details);
        // let selectedLanguage = brand_details.language ? brand_details.language : 'english';
        // i18n.changeLanguage(selectedLanguage);
        // localStorage.setItem('selectedLanguage', selectedLanguage);
      }
      LocalStorage.setItem('initial-load', JSON.stringify(data));
    }
    navigate(location.pathname, { state: null });
  };

  // const handleTrailPlanPopup = () => {
  //   if (checkForFreeTrailPopup()) {
  //     setTimeout(() => {
  //       if (checkForFreeTrailPopup()) {
  //         setShowPlanDetailsPopup(true);
  //         LocalStorage.setItem('showPlanDetailsPopupOnce', 'true');
  //       }
  //     }, 5000);
  //   }
  // };

  // const checkForFreeTrailPopup = () => {
  //   let showPopup = false;
  //   let isTrailPopupLoaded = LocalStorage.getItem('showPlanDetailsPopupOnce');
  //   if (!isTrailPopupLoaded) {
  //     //let route = Routes.PrivateRoute().find((a) => a.path === location.pathname.replace('/', ''));
  //     if (
  //       //  route &&
  //       !trailPlanDisplay?.has_subscription &&
  //       !trailPlanDisplay?.has_trail_plan &&
  //       !trailPlanDisplay.is_appsumo_user
  //     ) {
  //       showPopup = true;
  //     }
  //   }
  //   return showPopup;
  // };

  const closePopup = () => {
    setShowPlanDetailsPopup(false);
  };

  // Payment recovery is independent of dashboard menu/header state, including
  // the first render after a billing redirect or a direct page reload.
  if (isBrandPaymentRoute) {
    return (
      <main style={{ width: '100%', minHeight: '100dvh', paddingTop: 24, paddingBottom: 24 }}>
        <MainPage isDesktop={isDesktop} pathname={location.pathname} routes={publicRoutes} />
      </main>
    );
  }

  return (
    <>
      {/* {showPlanDetailsPopup && <TrialPlanDetailsPopup closePopup={closePopup} />} */}
      {isRouteLoaded ? (
        isDesktop ? (
          <>
            {headerName && (
              <Header
                headerName={headerName}
                isShowOfferBanner={isShowOfferBanner}
                onOpenSupportChat={() => setSupportChatOpen(true)}
              />
            )}
            {showSideBar ? (
              <div style={{ display: 'flex', flexDirection: 'row', minHeight: '100%', height: '100vh' }}>
                <ProfileSection handleChangeBrand={handleChangeBrand} handleInitCall={handleInitCall} />
                <MenuBarComponent
                  isMainMenuBarView={isMainMenuBarView}
                  menuItems={menuItems}
                  backButtonClick={backButtonClick}
                  handleChangeBrand={handleChangeBrand}
                  handleInitCall={handleInitCall}
                  isShowOfferBanner={isShowOfferBanner}
                />
                <MainPage pathname={location.pathname} routes={routes} isShowOfferBanner={isShowOfferBanner} />
              </div>
            ) : (
              <MainPage pathname={location.pathname} routes={routes} isShowOfferBanner={isShowOfferBanner} />
            )}
          </>
        ) : (
          <>
            {headerName && <MobileHeader handleChangeBrand={handleChangeBrand} headerName={headerName} />}
            <MainPage isDesktop={false} pathname={location.pathname} routes={routes} />
            {headerName && (
              <Footer>
                <FooterSection />
              </Footer>
            )}
          </>
        )
      ) : (
        <>
          <Spinner />
        </>
      )}
      {/* <SupportChat open={isSupportChatOpen} onClose={() => setSupportChatOpen(false)} /> */}
    </>
  );
};

export default MainComponent;
